<template>
  <div>


  <div class="cols">
    <div class="zt5" v-if="list.length > 0" v-for="(itm, i) in list" :key="i">
      <div class="tz2">
        <div class="tt">
          <div class="sn">
            <img class="logo" src="~@/../static/v2/order/logo.png" mode="widthFix"/>
            {{ itm.sn }}
          </div>
          <div :class="'status status_'+itm.status"> {{ itm.strs.status }} </div>
        </div>
        <div class="tt" v-if="itm.processing_text">
          <div class="ts">
            {{ itm.processing_text }}
          </div>
        </div>
      </div>
      <div class="mid_boder">
        <img class="mid_boder_img " src="~@/../static/v2/order/boder.png" mode="widthFix"/>
      </div>

      <div class="staterandtime">
        <div class="date">
          {{ itm.date}}
        </div>
        <div class="top">
          <div class="start" @click="show_point(itm.fmt.start_obj)">
            <div class="">
         
              {{ itm.fmt.start_tit }}
            </div>
          </div>
          <div class="mmd">
            <img src="~@/../static/v3/rjt.png" mode="widthFix"/>
          </div>
          <div class="end"  @click="show_point(itm.fmt.end_obj)">
            <div class="">
              {{ itm.fmt.end_tit }}
            </div>
          </div>
        </div>

        <div class="flex_between">
          <div class="sesese">
            {{ itm.fmt.start_time}}
          </div>
          <div class="sesese seseser">
            {{ itm.fmt.end_time}}
          </div>
        </div>
      </div>

      <div class="mid_boder">
        <img class="mid_boder_img " src="~@/../static/v2/order/boder.png" mode="widthFix"/>
      </div>
      <div class="boot1">
        <div class="info">
          <div class="is">
            {{ $lang(42630)}}： <span class="eeee"> {{ to_hi(itm.pay_time) }} </span>
          </div>
          <div class="is">
            {{$lang(42366)}}： <span class="eeee"> {{itm.mail}} </span>
          </div>

          <div v-for="(vo, x) in itm.contacts" :key="x" class="is">
            {{$lang(106462)}}：
            <div class="it">
              <span class="eeee e1">
                {{ vo.name}}
              </span>
              <span class="eeee e2">
                {{ vo.strs.sex}}
              </span>
              <span class="eeee e3">
                {{ vo.age}}
              </span>
              <span class="eeee e4">
                {{ $lang(42361)}}
              </span>
            </div>
          </div>
        </div>

        <div class="price">
          {{itm.amount}} {{ $lang(42374) }}
        </div>
      </div>

      <div class="boot2">
        <div class="btns">
          <template v-if="itm.status == 1">
            <div class="b_tn" v-if="itm.is_urgent == 0" @click="do_urgent(i)">
              {{ $lang(42635)}}
            </div>
            <div class="b_tn" v-else>
              {{ $lang(42643)}}
            </div>
          </template>

          <div class="b_tn" v-if="itm.status==2" @click="show_ticket(itm.sn)">
            {{$lang(44950)}}
          </div>

          <div class="b_tn" v-if="itm.status==0" @click="jump('/hot/pay?sn=' + itm.sn)">
            {{$lang(42644)}}
          </div>

          <div class="b_tn" v-if="itm.strs.show_btn" @click="show_back(i)"> {{$lang(50942)}}</div>
          <div class="b_tn" v-if="itm.back_status > 0" @click="show_note(i)">{{itm.strs.back_status}}
          </div>
        </div>
      </div>
    </div>

 
  </div>

  <div v-if="list.length == 0">
            <div>
                <el-empty marginTop="200" margin mode="data">
            </el-empty>
            <div class="" style="height: 200px;">
            </div>
            </div>
          
        </div>
        <el-pagination background layout="prev, pager, next"
        
        :current-page="list.current_page"
            :page-size="list.per_page" :total="list.total" @current-change="change_page">
        </el-pagination>
</div>
</template>

<script>
export default {
  name: 'hot_line_list',
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  methods: {
    to_hi(time) {
      return time;
    },
    do_urgent(index) {
      this.$emit('do-urgent', index);
    },
    show_ticket(sn) {
      this.$emit('show-ticket', sn);
    },
    show_point(sn) {
      this.$emit('show-point', sn);
    },
    jump(path) {
      this.$emit('jump', path);
    },
    show_back(index) {
      this.$emit('show-back', index);
    },
    show_note(index) {
      this.$emit('show-note', index);
    }, change_page(page) {
            this.$emit('change-page', page);
        }

  }
}
</script>

<style lang="scss" scoped>
@import url('./pc_order.scss');
</style>


// WEBPACK FOOTER //
// src/components/hot_line_list.vue